export default __webpack_public_path__ + "static/media/ic_usdc_24.0952740b.svg";